var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-logo",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{attrs:{"alt":"Logo","src":require(("@/assets/img/" + _vm.project + "/logofull.svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }